import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  testManagementPageTitle: {
    id: 'frontbucket.pipelines.components.testManagement.testsPageTitle',
    description: 'The title for the Tests page',
    defaultMessage: 'Tests',
  },
  testManagementPageSummary: {
    id: 'frontbucket.pipelines.components.testManagement.testsPageSummary',
    description: 'The summary text for the Tests page',
    defaultMessage:
      'Organize, control, and track every aspect of software testing within your development lifecycle. Tests help you centralize test data, monitor execution, and gain actionable insights to boost quality and streamline delivery. Data is calculated from the most recent 90 days of test executions.',
  },
  testingSupportDocsLink: {
    id: 'frontbucket.pipelines.components.testManagement.bitbucketCloudTestingSupportDocsLink',
    description: 'Link text for Bitbucket Cloud testing support documentation',
    defaultMessage: 'Get organized with Tests',
  },
  testExecutionPageTitle: {
    id: 'frontbucket.pipelines.components.testManagement.testExecutionPageTitle',
    description: 'The title for the Test execution page',
    defaultMessage: 'Test execution',
  },
  test: {
    id: 'frontbucket.pipelines.components.testManagement.test',
    description: 'The test management table head column name for test name',
    defaultMessage: 'Test name',
  },
  testState: {
    id: 'frontbucket.pipelines.components.testManagement.testState',
    description: 'The test management table head column name for test state',
    defaultMessage: 'Test state',
  },
  labels: {
    id: 'frontbucket.pipelines.components.testManagement.labels',
    description: 'The test management table head column name for Labels',
    defaultMessage: 'Labels',
  },
  failureRate: {
    id: 'frontbucket.pipelines.components.testManagement.failureRate',
    description: 'The test management table head column name for Failure Rate',
    defaultMessage: 'Failure rate',
  },
  flakinessScore: {
    id: 'frontbucket.pipelines.components.testManagement.flakinessScore',
    description:
      'The test management table head column name for Flakiness Score',
    defaultMessage: 'Flakiness score',
  },
  averageDuration: {
    id: 'frontbucket.pipelines.components.testManagement.averageDuration',
    description:
      'The test management table head column name for Average Duration',
    defaultMessage: 'Average duration',
  },
  actions: {
    id: 'frontbucket.pipelines.components.testManagement.actions',
    description: 'The test management table head column name for Actions',
    defaultMessage: 'Actions',
  },
  tags: {
    id: 'frontbucket.pipelines.components.testManagement.tags',
    description: 'The test management table head column name for Tags',
    defaultMessage: 'Tags',
  },
  labelFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.labelFilterPlaceholder',
    description: 'The test management table label filter placeholder',
    defaultMessage: 'Search comma separated labels',
  },
  tagsPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.tagsPlaceholder',
    description: 'The test management table tags filter placeholder',
    defaultMessage: 'Tags',
  },
  testFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.testFilterPlaceholder',
    description: 'The test management table name filter placeholder',
    defaultMessage: 'Test name',
  },
  fullyQualifiedNameLabel: {
    id: 'frontbucket.pipelines.components.testManagement.fullyQualifiedNameLabel',
    description: 'The test management table fully qualified name label',
    defaultMessage: 'Fully qualified name',
  },
  classNameLabel: {
    id: 'frontbucket.pipelines.components.testManagement.classNameLabel',
    description: 'The test management table class name label',
    defaultMessage: 'Class name',
  },
  p90OfDuration: {
    id: 'frontbucket.pipelines.components.testManagement.p90OfDuration',
    description: 'The test management table p90 of duration label',
    defaultMessage: 'P90 duration',
  },
  p10OfDuration: {
    id: 'frontbucket.pipelines.components.testManagement.p10OfDuration',
    description: 'The test management table p10 of duration label',
    defaultMessage: 'P10 of the duration',
  },
  emptyTableMessage: {
    id: 'frontbucket.pipelines.components.testManagement.emptyTableMessage',
    description: 'The test management table empty table message',
    defaultMessage: 'There are no tests to display',
  },
  build: {
    id: 'frontbucket.pipelines.components.testManagement.build',
    description: 'The table head column name for Build',
    defaultMessage: 'Build',
  },
  lastExecuted: {
    id: 'frontbucket.pipelines.components.testManagement.lastExecuted',
    description: 'The test execution table head column name for Last Executed',
    defaultMessage: 'Last executed',
  },
  outcome: {
    id: 'frontbucket.pipelines.components.testManagement.outcome',
    description: 'The table head column name for Outcome',
    defaultMessage: 'Outcome',
  },
  executionDuration: {
    id: 'frontbucket.pipelines.components.testManagement.executionDuration',
    description:
      'The test execution table head column name for Execution duration',
    defaultMessage: 'Execution duration',
  },
  variance: {
    id: 'frontbucket.pipelines.components.testManagement.variance',
    description: 'The test management table head column name for Variance',
    defaultMessage: 'Variance',
  },
  failureRateTooltip: {
    id: 'frontbucket.pipelines.components.testManagement.failureRateTooltip',
    description: 'Tooltip explanation for Failure Rate header',
    defaultMessage: 'Rate at which a test fails',
  },
  flakyScoreTooltip: {
    id: 'frontbucket.pipelines.components.testManagement.flakyScoreTooltip',
    description: 'Tooltip explanation for Flaky Score header',
    defaultMessage:
      'Scores are out of 100 and indicate how flaky a test is. Tests with higher scores are more flaky.',
  },
  averageDurationTooltip: {
    id: 'frontbucket.pipelines.components.testManagement.averageDurationTooltip',
    description: 'Tooltip explanation for Average Duration header',
    defaultMessage: 'Average time spent running a test',
  },
  varianceTooltip: {
    id: 'frontbucket.pipelines.components.testManagement.varianceTooltip',
    description: 'Tooltip explanation for Variance header',
    defaultMessage:
      'Difference in time between the longest and shortest test run',
  },
  viewLogs: {
    id: 'frontbucket.pipelines.components.testManagement.viewLogs',
    description: 'The table action to view logs',
    defaultMessage: 'View logs',
  },
  branchFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.branchFilterPlaceholder',
    description: 'The table branch filter placeholder',
    defaultMessage: 'Branch name',
  },
  commitFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.commitFilterPlaceholder',
    description: 'The table commit filter placeholder',
    defaultMessage: 'Commit hash',
  },
  executedAfterFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.executedAfterFilterPlaceholder',
    description: 'The table executed after filter placeholder',
    defaultMessage: 'Executed after',
  },
  executedBeforeFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.executedBeforeFilterPlaceholder',
    description: 'The table executed before filter placeholder',
    defaultMessage: 'Executed before',
  },
  statusFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.statusFilterPlaceholder',
    description: 'The table outcome filter placeholder',
    defaultMessage: 'Outcome',
  },
  targetTypeFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.targetTypeFilterPlaceholder',
    description: 'The table target type filter placeholder',
    defaultMessage: 'Target type',
  },
  testTypeFilterPlaceholder: {
    id: 'frontbucket.pipelines.components.testManagement.testTypeFilterPlaceholder',
    description: 'The test type filter placeholder text',
    defaultMessage: 'Filter',
  },
  referenceNameLabel: {
    id: 'frontbucket.pipelines.components.testManagement.referenceNameLabel',
    description: 'The table reference name label',
    defaultMessage: 'Reference name',
  },
  revisionLabel: {
    id: 'frontbucket.pipelines.components.testManagement.revisionLabel',
    description: 'The table revision label',
    defaultMessage: 'Revision',
  },
  commit: {
    id: 'frontbucket.pipelines.components.testManagement.commit',
    description: 'The test execution table head column name for Commit',
    defaultMessage: 'Commit',
  },
  ok: {
    id: 'frontbucket.pipelines.components.testManagement.ok',
    description: 'Text for OK label',
    defaultMessage: 'OK',
  },
  flaky: {
    id: 'frontbucket.pipelines.components.testManagement.flaky',
    description: 'Text for flaky label',
    defaultMessage: 'Flaky',
  },
  markFlaky: {
    id: 'frontbucket.pipelines.components.testManagement.markFlaky',
    description: 'Text for mark flaky label',
    defaultMessage: 'Mark flaky',
  },
  unmarkFlaky: {
    id: 'frontbucket.pipelines.components.testManagement.unmarkFlaky',
    description: 'Text for unmark flaky label',
    defaultMessage: 'Unmark flaky',
  },
  fixFlakyTest: {
    id: 'frontbucket.pipelines.components.testManagement.fixFlakyTest',
    description: 'Text for fix flaky label',
    defaultMessage: 'Fix flaky test',
  },
  fixFlakyPipelineSuccess: {
    id: 'frontbucket.pipelines.components.testManagement.fixFlakyPipelineSuccess',
    description:
      'Success message when fix-flaky-test action creates a pipeline',
    defaultMessage:
      'Pipeline #{number} created successfully. A fix has been generated by AI agent.',
  },
  viewPipelineNumber: {
    id: 'frontbucket.pipelines.components.testManagement.viewPipelineNumber',
    description: 'Link text to view the created pipeline',
    defaultMessage: 'View pipeline #{number}',
  },
  viewPullRequest: {
    id: 'frontbucket.pipelines.components.testManagement.viewPullRequest',
    description: 'Link text to view the pull request',
    defaultMessage: 'View pull request',
  },
  fixFlakyError: {
    id: 'frontbucket.pipelines.components.testManagement.fixFlakyError',
    description: 'Error message when fix-flaky-test action fails',
    defaultMessage: 'Failed to fix flaky test. Please try again.',
  },
  markAsQuarantined: {
    id: 'frontbucket.pipelines.components.testManagement.markAsQuarantined',
    description: 'Text for marking as quarantined label',
    defaultMessage: 'Mark as quarantined',
  },
  quarantine: {
    id: 'frontbucket.pipelines.components.testManagement.quarantine',
    description: 'Text for quarantine label',
    defaultMessage: 'Quarantine',
  },
  quarantined: {
    id: 'frontbucket.pipelines.components.testManagement.quarantined',
    description: 'Text for quarantined label',
    defaultMessage: 'Quarantined',
  },
  unmarkAsQuarantined: {
    id: 'frontbucket.pipelines.components.testManagement.unmarkAsQuarantined',
    description: 'Text for unmarking as quarantined label',
    defaultMessage: 'Unmark as quarantined',
  },
  executionTimeWarningTooltip: {
    id: 'frontbucket.pipelines.components.testManagement.executionTimeWarningTooltip',
    description: 'Text for execution time warning tooltip',
    defaultMessage: 'Slower than 90% of executions',
  },
  copyTestName: {
    id: 'frontbucket.pipelines.components.testManagement.copyTestName',
    description: 'Label for the copy test name button',
    defaultMessage: 'Copy test name',
  },
  copyAsText: {
    id: 'frontbucket.pipelines.components.testManagement.copyAsText',
    description: 'Tooltip text for copy as text action',
    defaultMessage: 'Copy as text',
  },
  copied: {
    id: 'frontbucket.pipelines.components.testManagement.copied',
    description: 'Tooltip text when copy action is successful',
    defaultMessage: 'Copied!',
  },
  quarantinedTestSummary: {
    id: 'frontbucket.pipelines.components.testManagement.quarantinedTestSummary',
    description: 'Summary for quarantined test icon',
    defaultMessage: 'Tests marked as quarantined are skipped during builds',
  },
  paidPlanRequiredHeader: {
    id: 'frontbucket.pipelines.components.testManagement.paidPlanRequiredHeader',
    description:
      'Header for the Test management page empty state when paid plan is required',
    defaultMessage:
      'Get a Standard or Premium monthly plan to unlock this functionality',
  },
  paidPlanRequiredDescription: {
    id: 'frontbucket.pipelines.components.testManagement.paidPlanRequiredDescription',
    description:
      'Description for the Test management page empty state when paid plan is required',
    defaultMessage:
      'Start a free trial to begin organizing, controlling, and tracking every aspect of software testing within your development lifecycle.',
  },
  explorePlans: {
    id: 'frontbucket.pipelines.components.testManagement.explorePlans',
    description: 'Label for the explore plans action button',
    defaultMessage: 'Explore plans',
  },
  learnMoreLink: {
    id: 'frontbucket.pipelines.components.testManagement.learnMoreLink',
    description: 'Text for the learn more link',
    defaultMessage: 'Learn more',
  },
  learnAboutTestManagement: {
    id: 'frontbucket.pipelines.components.testManagement.learnAboutTestManagement',
    description: 'Label for the learn more about test management link',
    defaultMessage: 'Learn about Tests',
  },
  markedAsActionByUser: {
    id: 'frontbucket.pipelines.components.testManagement.markedAsActionByUser',
    description: 'Text for the marked as action by label with the user name',
    defaultMessage: 'Marked as {action} by {user}',
  },
  unmarkedAsActionByUser: {
    id: 'frontbucket.pipelines.components.testManagement.unmarkedAsActionByUser',
    description: 'Text for the unmarked as action by label with the user name',
    defaultMessage: 'Unmarked as {action} by {user}',
  },
  configureDetectionLabel: {
    id: 'frontbucket.pipelines.components.testManagement.configureDetectionLabel',
    description: 'Label for the configure detection action button',
    defaultMessage: 'Configure detection',
  },
  initiatorUser: {
    id: 'frontbucket.pipelines.components.testManagement.initiatorUser',
    description: 'Text for the initiator user label',
    defaultMessage: 'Initiator: {user}',
  },
  fixFlakyUnavailable: {
    id: 'frontbucket.pipelines.components.testManagement.fixFlakyUnavailable',
    description: 'Text for the fix flaky unavailable message',
    defaultMessage:
      'Fix flaky AI agent has not been set up to automatically fix flaky tests. {learnMoreLink}',
  },
  removeTest: {
    id: 'frontbucket.pipelines.components.testManagement.removeTest',
    description: 'Label for the remove test action',
    defaultMessage: 'Remove test',
  },
  removeTestModalTitle: {
    id: 'frontbucket.pipelines.components.testManagement.removeTestModalTitle',
    description: 'Title for the remove test modal',
    defaultMessage: 'Remove test from test list?',
  },
  removeTestConfirmMessage: {
    id: 'frontbucket.pipelines.components.testManagement.removeTestConfirmMessage',
    description: 'Confirmation message for the remove test modal',
    defaultMessage:
      'This will remove {testName} from the test list. It will appear again the next time the test runs.',
  },
  removeTestConfirmButton: {
    id: 'frontbucket.pipelines.components.testManagement.removeTestConfirmButton',
    description: 'Label for the confirm button in remove test modal',
    defaultMessage: 'Remove',
  },
  removeTestCancelButton: {
    id: 'frontbucket.pipelines.components.testManagement.removeTestCancelButton',
    description: 'Label for the cancel button in remove test modal',
    defaultMessage: 'Cancel',
  },
  deleteTestCaseSuccessTitle: {
    id: 'frontbucket.pipelines.components.testManagement.deleteTestCaseSuccessTitle',
    description: 'Title for the delete test case success message',
    defaultMessage: 'Test removed from list',
  },
  deleteTestCaseSuccessBody: {
    id: 'frontbucket.pipelines.components.testManagement.deleteTestCaseSuccessBody',
    description: 'Body for the delete test case success message',
    defaultMessage:
      '{testName} was removed from the list. It will appear again after it runs next time.',
  },
  deleteTestCaseErrorTitle: {
    id: 'frontbucket.pipelines.components.testManagement.deleteTestCaseErrorTitle',
    description: 'Title for the delete test case error message',
    defaultMessage: "Couldn't remove test",
  },
  deleteTestCaseErrorBody: {
    id: 'frontbucket.pipelines.components.testManagement.deleteTestCaseErrorBody',
    description: 'Body for the delete test case error message',
    defaultMessage:
      "We couldn't remove this test from the list. Try again in a few moments.",
  },
  selectedTestsCount: {
    id: 'frontbucket.pipelines.components.testManagement.selectedTestsCount',
    description:
      'Label that shows how many test rows are currently selected in the table',
    defaultMessage:
      '{count, plural, one {# test selected} other {# tests selected}}',
  },
  clearSelection: {
    id: 'frontbucket.pipelines.components.testManagement.clearSelection',
    description:
      'Button label that clears the current multi-row selection in the test table',
    defaultMessage: 'Clear selection',
  },
  bulkUpdateAttributesSuccessTitle: {
    id: 'frontbucket.pipelines.components.testManagement.bulkUpdateAttributesSuccessTitle',
    description:
      'Title of the success flag shown after bulk-toggling the flaky attribute',
    defaultMessage: '{count, plural, one {test} other {tests}} updated',
  },
  bulkUpdateAttributesSuccessBody: {
    id: 'frontbucket.pipelines.components.testManagement.bulkUpdateAttributesSuccessBody',
    description: 'Body for the bulk update attributes success message',
    defaultMessage:
      '{count, plural, one {# test} other {# tests}} were updated.',
  },
  bulkUpdateAttributesErrorTitle: {
    id: 'frontbucket.pipelines.components.testManagement.bulkUpdateAttributesErrorTitle',
    description:
      'Title of the error flag shown when bulk-toggling the flaky attribute fails',
    defaultMessage: "Couldn't update tests",
  },
  bulkUpdateAttributesErrorBody: {
    id: 'frontbucket.pipelines.components.testManagement.bulkUpdateAttributesErrorBody',
    description: 'Body for the bulk update attributes error message',
    defaultMessage: "We couldn't update the tests. Try again in a few moments.",
  },
  bulkRemoveTestsSuccessTitle: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsSuccessTitle',
    description:
      'Title of the success flag shown after bulk-removing tests from the list',
    defaultMessage:
      '{count, plural, one {test} other {tests}} removed from list',
  },
  bulkRemoveTestsSuccessBody: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsSuccessBody',
    description: 'Body for the bulk remove tests success message',
    defaultMessage:
      '{count, plural, one {# test} other {# tests}} were removed from the list. Tests will appear again after they are run.',
  },
  bulkRemoveTestsErrorTitle: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsErrorTitle',
    description: 'Title of the error flag shown when bulk-removing tests fails',
    defaultMessage: "Couldn't remove tests",
  },
  bulkRemoveTestsErrorBody: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsErrorBody',
    description: 'Body of the error flag shown when bulk-removing tests fails',
    defaultMessage:
      "We couldn't remove the tests from the list. Try again in a few moments.",
  },
  bulkRemoveTestsModalTitle: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsModalTitle',
    description: 'Title for the bulk remove tests confirmation modal',
    defaultMessage:
      'Remove {count, plural, one {# test} other {# tests}} from test list?',
  },
  bulkRemoveTestsModalBody: {
    id: 'frontbucket.pipelines.components.testManagement.bulkRemoveTestsModalBody',
    description: 'Body text for the bulk remove tests confirmation modal',
    defaultMessage:
      'This will remove {count, plural, one {# test} other {# tests}} from the test list. They will appear again the next time the tests run.',
  },
  createJiraWorkItem: {
    id: 'frontbucket.pipelines.components.testManagement.createJiraWorkItem',
    description:
      'Label for the action that opens a modal to create a Jira work item from a failing/flaky test',
    defaultMessage: 'Create Jira work item',
  },
  createJiraWorkItemSummary: {
    id: 'frontbucket.pipelines.components.testManagement.createJiraWorkItemSummary',
    description:
      'Pre-populated summary text for the Jira issue created from a failing test',
    defaultMessage: 'Investigate flaky test: {testName}',
  },
  createJiraWorkItemDescriptionLine1: {
    id: 'frontbucket.pipelines.components.testManagement.createJiraWorkItemDescriptionLine1',
    description:
      'First line of the pre-populated description for the Jira work item created from a test',
    defaultMessage:
      'A Jira issue was created from a Bitbucket test result for repository {repository}.',
  },
  createJiraWorkItemDescriptionLine2: {
    id: 'frontbucket.pipelines.components.testManagement.createJiraWorkItemDescriptionLine2',
    description:
      'Second line of the pre-populated description for the Jira work item created from a test',
    defaultMessage: 'Test name: {testName}',
  },
  createJiraWorkItemDescriptionLine3: {
    id: 'frontbucket.pipelines.components.testManagement.createJiraWorkItemDescriptionLine3',
    description:
      'Third line of the pre-populated description for the Jira work item created from a test',
    defaultMessage: 'Test ID: {testUuid}',
  },
});
